import { render, staticRenderFns } from "./labelCell.vue?vue&type=template&id=e0ad46f6&scoped=true"
import script from "./labelCell.vue?vue&type=script&lang=js"
export * from "./labelCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ad46f6",
  null
  
)

export default component.exports